import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Divider } from '@material-ui/core';

import Aux from '../../../hoc/NoParent';
import buildNavigationItemsList from './NavigationItems';
import NavigationMenu from './NavigationMenu';

class Navigation extends Component {
    render() {
        const { onCloseHandler, isInstalledApp, installAppPrompt } = this.props;
        const navigationItems = buildNavigationItemsList(isInstalledApp, installAppPrompt);
        const lastItemIndex = navigationItems.length - 1;
        
        return navigationItems.map(({ menuItems }, index) => {
            menuItems = menuItems.map(({ onClick, ...item }) => {
                const onClickHandler = onClick ? () => { onClick(); onCloseHandler(); } : onCloseHandler;
    
                return { ...item, onClick: onClickHandler }
            });
            return (
                <Aux key={index}>
                    <NavigationMenu component={NavLink} menuItems={menuItems} />
                    { index === lastItemIndex ? null : <Divider />}
                </Aux>
            );
        });
    }    
}

const mapStateToProps = state => {
    return {
        isInstalledApp: state.addToHomeScreen.isInstalled, 
        installAppPrompt: state.addToHomeScreen.promptEvent
    };
};

export default connect(mapStateToProps, null)(Navigation);